
	export default {
		created(){
			console.log('from channel', this.$parent.educator)
		}
	}
